<sim-basic-material-dialog
	(closeClicked)="close({action: 'cancel'})"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-link', fontSet: 'fad'}"
	[headerText]="T.EXAM_FLOW_SESSIONS_DIALOG_TITLE | translate"
	[matDialogData]="data"
	[overflowHandledByChild]="true"
	[rect]="rect"
	[smallHeader]="true"
>
	<ng-container dialogContent>
		<sim-list [noBorder]="true" icon="fa-cubes" [label]="T.EXAM_FLOW_SESSIONS_DIALOG_LIST_HEADER" gap="1.5rem">
			@for (session of sessions(); track session.id) {
				<sim-session-card [session]="session" [creationMode]="true" />
			}
		</sim-list>
	</ng-container>
</sim-basic-material-dialog>
